module.exports = __webpack_public_path__ + "static/Derophotohero-f35ec194082b03204a188375f2c1686b.jpg";